module.exports = __webpack_public_path__ + "static/media/calendar.57b83dde.svg";